import { theme } from 'antd';
import React from 'react';
import { Button, Col, Flex, Row, Typography } from 'zui/Antd';

const { Text, Title } = Typography;

const RenderHeaderSetting = ({
	title,
	description,
	showDiscardButton,
	showSaveButton,
	onClickDiscard,
	onClickSave,
	disableSaveButton,
	loadingSaveButton,
	form
}) => {
	const {
		token: { marginMD, colorTextLabel }
	} = theme.useToken();

	return (
		<Row gutter={[marginMD, 0]} style={{ marginBottom: marginMD }} align='top'>
			<Col span={24}>
				<Title level={5} style={{ margin: 0 }}>
					{title}
				</Title>
			</Col>
			<Col xs={24} md={24}>
				<Flex justify='space-between' wrap gap={20} align='start'>
					<Text style={{ color: colorTextLabel, width: '70%' }}>{description}</Text>
					<Flex flex={1} justify='flex-end' gap={12}>
						{showDiscardButton && <Button onClick={() => onClickDiscard()}>Cancel</Button>}
						{showSaveButton && (
							<Button
								title='Save Changes'
								disabled={disableSaveButton}
								loading={loadingSaveButton}
								onClick={() => onClickSave()}
								form={form}
								type='primary'
							>
								Save Changes
							</Button>
						)}
					</Flex>
				</Flex>
			</Col>
		</Row>
	);
};

export default RenderHeaderSetting;
